import React, { FC } from 'react';
import _ from '@dh-fe/translate';
import Button from 'components/Button';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import styles from './style.module.scss';

const PromotionBanner: FC<Props> = ({ link, isVisible, close }) => {
    const { theme, isLiveJasmin } = useTheme();
    return (
        <>
            {' '}
            {isVisible && (
                <div className={`${styles[theme]} ${styles.root} ${styles.promotionBannerWrapper}`}>
                    <button className={styles.close} onClick={close}>
                        <i className="icon-gallery-close-x" />
                    </button>
                    <div className={classnames(styles.icon, styles.iconVibes)} />
                    <p className={styles.text}>{_`Boost your earnings by keeping your contacts in your pocket!`}</p>
                    <div className={styles.buttonWrapper}>
                        <Button
                            className={styles.button}
                            size="s"
                            type={isLiveJasmin ? 'secondary1' : 'primary'}
                            href={link}
                            target="_blank"
                        >{_`Get`}</Button>
                    </div>
                </div>
            )}
        </>
    );
};

interface Props {
    link?: string;
    isVisible?: boolean;
    close: () => void;
}

export default PromotionBanner;
export { PromotionBanner };
